import { FC, SVGProps } from 'react';

export const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.333 9.99948L7.26129 4.16663L5.83301 5.53895L10.4795 10.0034L5.83301 14.461L7.26129 15.8333L13.333 9.99948Z" fill="currentColor" />
  </svg>
);
